interface HiddenUsernameFieldProps {
  /** The username (typically email) to pair the password with in password managers. */
  username: string;
  /** Accessible name announced when a screen-reader tabs to the field — pass the
   *  localized label (e.g. "Benutzername") from the consumer's i18n layer. */
  label: string;
}

/** Off-screen `autoComplete="username"` input that lets password managers pair a
 *  new- or current-password field with the right account. Positioned off-screen
 *  rather than `display:none` / `hidden` attribute / `visibility:hidden`, and
 *  deliberately without `aria-hidden` or `tabIndex={-1}` — Chrome's autofill
 *  treats those as "non-interactable" and skips the field, which breaks the
 *  password-manager pairing the field exists to provide. */
export function HiddenUsernameField({ username, label }: HiddenUsernameFieldProps) {
  return (
    <input
      type="text"
      name="username"
      autoComplete="username"
      aria-label={label}
      value={username}
      readOnly
      className="absolute -left-[9999px]"
    />
  );
}
